module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.is_manager) ? _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "6%",
      "margin-left": "33%",
      "float": "center"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "基础文档"
    }
  }, [_c('el-cascader', {
    ref: "cascader",
    attrs: {
      "change-on-select": "",
      "options": _vm.form.options,
      "clearable": ""
    },
    model: {
      value: (_vm.basePage),
      callback: function($$v) {
        _vm.basePage = $$v
      },
      expression: "basePage"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "映射文档"
    }
  }, [_c('el-cascader', {
    ref: "cascader",
    attrs: {
      "change-on-select": "",
      "options": _vm.form.options,
      "clearable": ""
    },
    model: {
      value: (_vm.relaPage),
      callback: function($$v) {
        _vm.relaPage = $$v
      },
      expression: "relaPage"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.checkSubmit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48501788!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/addLangIndex.vue
// module id = 644
// module chunks = 1